import {
    EMPTY_ATTRIBUTES_FILTER,
    EMPTY_CUSTOMER_FILTER,
    EMPTY_CUSTOMER_NUMBER_FILTER,
    EMPTY_HEADER_FILTER,
    EMPTY_MODEL_FILTER,
    EMPTY_ORDER_NUMBER_FILTER,
    EMPTY_PLAN_FILTER,
    EMPTY_STATUS_FILTER,
    orderStatus
} from "../OrderStatus";
import {matchEmptyOrIncludes} from "../../utils/common/matchEmptyOrIncludes";

export const OrderTableFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_ORDER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "customer",
        "id": "customerName",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_FILTER, options)
    },
    {
        "idFromColumnFilter": "header",
        "id": "header", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_HEADER_FILTER, options)
    },
    {
        "idFromColumnFilter": "models",
        "id": "estimate",
        "field": "modules",
        "filterFn": (value, filterValue, _enum, options) => {
            const names = (value || []).map((module) => module?.originalName).filter(Boolean)
            if (filterValue === EMPTY_MODEL_FILTER) {
                return names.length === 0
            }
            const needle = String(filterValue ?? '').toLowerCase()
            return names.some((name) => options?.exact
                ? name.toLowerCase() === needle
                : name === filterValue || name.toLowerCase().includes(needle))
        }
    },
    {
        "idFromColumnFilter": "numberCustomer",
        "id": "numberCustomer",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "plan",
        "id": "plan", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_PLAN_FILTER, options)
    },
    {
        "idFromColumnFilter": "dateOfReceipt",
        "id": "dateOfReceipt",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "dateOfPlannedProduction",
        "id": "dateOfPlannedProduction",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "plannedDateOfShipment",
        "id": "plannedDateOfShipment",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "manufactured",
        "id": "manufactured",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "shipped",
        "id": "shipped",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "dateOfCreate",
        "id": "dateOfCreate",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "status",
        "id": "status",
        "filterFn": (value, filterValue, _enum, options) => {
            if (filterValue === EMPTY_STATUS_FILTER) {
                return value == null || value === '' || orderStatus[value] == null
            }
            const label = orderStatus[value]?.toLowerCase()
            if (!label) {
                return false
            }
            const filter = String(filterValue).toLowerCase()
            return options?.exact ? label === filter : label.includes(filter)
        }
    },
    {
        "idFromColumnFilter": "attributes",
        "id": "attributes",
        "filterFn": (value, filterValue, _enum, options) => {
            if (filterValue === EMPTY_ATTRIBUTES_FILTER) {
                return !value || value.length === 0
            }
            if (!Array.isArray(value)) {
                return false
            }
            const filter = String(filterValue).toLowerCase()
            return value.some((el) => {
                const name = el.name?.toLowerCase()
                if (!name) {
                    return false
                }
                return options?.exact ? name === filter : name.includes(filter)
            })
        }
    }
]
